import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Modal,
  Stack,
  styled,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactSignatureCanvas from "react-signature-canvas";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey, BILightGreen, BILightGrey, BILightRed } from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  DELETE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS2_IMAGES,
  FETCH_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS2,
  FETCH_CLIENT_QC_PACKAGE_ITEMS2,
  SAVE_CLIENT_JOB_PACKAGE_ACTIVITY,
  SAVE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS,
  SAVE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS_IMAGES,
  SAVE_CLIENT_QC_JOB_PACKAGE_ITEM_ENTRIES
} from "../../constant/Apipath";
import { forEach } from "lodash";
import { Token } from "@mui/icons-material";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
let CLIENT_COLOR;

export const ClientQualityControlModel = ({ isOpen, onClose, selectedPackage, reLoadData }) => {
  const { loginData, selectedClientData } = useSelector((state) => state.main);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const {
    TEXT_DETAILS_DRAFT,
    TEXT_DETAILS_PASS,
    TEXT_DETAILS_FAIL,
    TEXT_DETAILS_DONE,
    TEXT_DETAILS_INSPECTION,
    TEXT_DETAILS_ADD_PICTURE,
    TEXT_MODAL_DISCARD,
    TEXT_SAVE_DRAFT,
    TEXT_DETAILS_COMPLETED_SIGNED_OFF,
    TEXT_SIGNATURE,
    TEXT_DETAILS_SUBMIT,
    TEXT_WRITE_SOMETHING,
    TEXT_REQUIRED,
    TEXT_DETAILS_NO_DATA
  } = ClientEnglishFallback.QualityControlModal(multiLanguageData?.QualityControlModal || {});
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const userId = loginData?.userInformation?.UserId;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const inputRef = useRef();

  const [showPictureView, setShowPictureView] = useState(false);
  const [pictureListArray, setPictureListArray] = useState([]);
  const [deletImagesList, setDeleteImagesList] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [adImageIndex, setAdImageIndex] = useState(null);
  const [modalHeading, setModelHeading] = useState("");
  const [pictureIndex, setPictureIndex] = useState();
  const [saveDraft, setSaveDraft] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [signBlob, setSignBlob] = useState(null);
  const [data, setData] = useState([]);
  const [count, setCount] = useState({
    passCount: 0,
    failCount: 0
  });

  useEffect(() => {
    getTheCount();
  }, [data]);

  useEffect(() => {
    if (isOpen) {
      fetchPackages();
    }
  }, [isOpen]);

  const deleteImage = useCallback(async () => {
    try {
      let payload = {
        UserId: userId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [...deletImagesList]
      };

      let res = Postrequestcall(DELETE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS2_IMAGES, payload, TOKEN);
      setDeleteImagesList([]);
    } catch (error) {
      console.log("deleteImage-> Error Deleting Client Job Package Actibity Items Image: ", error);
    }
  }, [deletImagesList]);

  const handelImageRemove = useCallback(
    (mainIndex, index1, item) => {
      if (item?.id) {
        let DeleteList = [...deletImagesList];
        DeleteList.push({ id: item?.id });
        setDeleteImagesList(DeleteList);
      }
      setIsEdited(true);

      setData((prev) =>
        prev?.map((item, i) => {
          if (i === mainIndex) {
            return {
              ...item,
              pictureList: item?.pictureList?.filter((img, imgIndex) => imgIndex !== index1)
            };
          }
          return item;
        })
      );
    },
    [deletImagesList]
  );

  const handleAddPicture = async (list, jobPackageId, packageItemId) => {
    const localItems = list?.filter((item) => item?.isLocal);

    const uploadPromises = localItems?.map(async (item) => {
      const formData = new FormData();
      formData.append("Id", 0);
      formData.append("JobPackageId", jobPackageId);
      formData.append("PackageItemId", packageItemId);
      formData.append("FileName", item?.file);
      formData.append("ClientId", selectedClientData?.ClientId);
      formData.append("ModifiedBy", userId);

      return Fileuploadrequestcall(SAVE_CLIENT_JOB_PACKAGE_ACTIVITY_ITEMS_IMAGES, formData, TOKEN);
    });

    return Promise.all(uploadPromises);
  };

  const onSubmit = async (isDraft) => {
    setLoadingButton(true);
    if (deletImagesList?.length > 0) {
      deleteImage();
    }

    try {
      const date = moment().toISOString();
      const formData = new FormData();
      formData.append("id", selectedPackage?.jobsPackageEntryId || 0);
      formData.append("JobPackageId", selectedPackage?.id);
      formData.append("IsSubmit", !isDraft);
      if (signBlob) {
        formData.append("Signature", signBlob);
      }
      formData.append("SubmitDate", isDraft ? "" : date);
      formData.append("IsDraft", isDraft);
      formData.append("ClientId", selectedClientData?.ClientId);
      formData.append("ModifiedBy", userId);

      await Fileuploadrequestcall(SAVE_CLIENT_JOB_PACKAGE_ACTIVITY, formData, TOKEN);

      await Promise.all(
        data.map(async (item) => {
          const saveObj = {
            UserId: userId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: item?.packageItemsEntryId,
                JobPackageId: item?.jobPackageId,
                PackageItemId: item?.id,
                Comment: item?.comment,
                ItemInspectionStatus: item?.itemInspectionStatus || "draft",
                ClientId: selectedClientData?.ClientId,
                ModifiedBy: userId
              }
            ]
          };

          const res = await Postrequestcall(
            SAVE_CLIENT_QC_JOB_PACKAGE_ITEM_ENTRIES,

            saveObj,
            TOKEN
          );

          if (res?.status === 201) {
            const packageItemId = res?.data?.data?.[0]?.objData?.packageItemId;
            const jobPackageId = res?.data?.data?.[0]?.objData?.jobPackageId;
            await handleAddPicture(item?.pictureList, jobPackageId, packageItemId);
          }
        })
      );
      handelBothTheModalClose();
      setLoadingButton(false);
      reLoadData();
    } catch (error) {
      console.error("onSubmit-> Error Saving File: ",error);
      throw error;
    }
  };

  const fetchPackages = async () => {
    try {
      setIsLoading(true);
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            jobPackageId: selectedPackage.id
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_QC_PACKAGE_ITEMS2, obj, TOKEN);
      if (res?.status === 200) {
        let data = res?.data?.data;
        if (data?.length > 0) {
          setData(data);
          setModelHeading(data[0]?.packageName);
        }
      }
    } catch (error) {
      console.error("fetchPackages-> Error getting Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const isButtonDisabled = () => {
    return data.some((inspection) => {
      let isCommentValid =
        inspection.isCommentMandatory && inspection.itemInspectionStatus !== "NA"
          ? inspection.comment.trim() === ""
            ? true
            : false
          : false;

      const isPictureValid =
        inspection.isPictureMandatory && inspection.itemInspectionStatus !== "NA"
          ? inspection.pictureList.length === 0
            ? true
            : false
          : false;

      if (signBlob == null) {
        return true;
      }
      return isCommentValid || isPictureValid;
    });
  };

  const handelIsEdited = () => {
    setIsEdited(true);
  };

  const getTheCount = () => {
    let passCount = 0;
    let failCount = 0;
    let totalCount = data?.length;
    data.forEach((item) => {
      if (item.itemInspectionStatus == "pass") {
        passCount++;
      } else if (item.itemInspectionStatus == "fail") {
        failCount++;
      } else if (item.itemInspectionStatus == "NA") {
        totalCount--;
      }
    });
    setCount({ passCount, failCount, totalCount });
  };

  const handleTextChange = (e, id) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    handelIsEdited();
    setData((prevData) =>
      prevData?.map((item) => (item.id === id ? { ...item, comment: inputValue } : item))
    );
  };

  const handelImageChange = (event) => {
    handelIsEdited();
    const files = event.target.files;
    const newImages = [...data[adImageIndex].pictureList];
    for (let i = 0; i < files.length; i++) {
      newImages.push({
        isLocal: true,
        file: files[i]
      });
    }
    setData((prev) =>
      prev?.map((item, index) => {
        if (index === adImageIndex) {
          return { ...item, pictureList: newImages };
        }
        return item;
      })
    );
    event.target.value = "";
  };

  const handelPass = (index) => {
    handelIsEdited();
    setData((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, itemInspectionStatus: "pass" } : item))
    );
  };
  const handelFail = (index) => {
    handelIsEdited();
    setData((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, itemInspectionStatus: "fail" } : item))
    );
  };
  const handelNa = (index) => {
    handelIsEdited();
    setData((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, itemInspectionStatus: "NA" } : item))
    );
  };

  const HandelMainModelClose = () => {
    if (isEdited) {
      setSaveDraft(true);
    } else {
      setIsEdited(false);
      setSaveDraft(false);
      setDeleteImagesList([]);
      setSignBlob(null);
      onClose();
      setData([]);
    }
  };

  const handelBothTheModalClose = () => {
    setSaveDraft(false);
    onClose();
    setIsEdited(false);
    setDeleteImagesList([]);
    setData([]);
    setSignBlob(null);
  };
  const ProgressBar = ({ passCount, failCount, total }) => {
    const passPercentage = (passCount / total) * 100;
    const failPercentage = (failCount / total) * 100;

    return (
      <Box sx={{ width: "100%", mt: 2 }}>
        {/* Labels */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1
          }}>
          <Box display={"flex"} gap={1}>
            <Typography variant="body2" sx={{ color: "green", fontWeight: "bold" }}>
              {passCount} {TEXT_DETAILS_PASS}
            </Typography>
            <Typography variant="body2" sx={{ color: "red", fontWeight: "bold" }}>
              {failCount} {TEXT_DETAILS_FAIL}
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {passCount + failCount}/{total} {TEXT_DETAILS_DONE}
          </Typography>
        </Box>

        {/* Progress Bar */}
        <Box
          sx={{
            display: "flex",
            height: 10,
            backgroundColor: "#e0e0e0",
            borderRadius: 5,
            overflow: "hidden",
            scrollbarWidth: "none"
          }}>
          {/* Green progress */}
          <Box
            sx={{
              width: `${passPercentage}%`,
              backgroundColor: "green"
            }}></Box>
          {/* Red progress */}
          <Box
            sx={{
              width: `${failPercentage}%`,
              backgroundColor: "red"
            }}></Box>
        </Box>
      </Box>
    );
  };

  const ClickableText = styled(Typography)(({ theme }) => ({
    cursor: "pointer",
    transition: " color 0.1s ease",
    "&:hover": {},

    userSelect: "none",
    "&:active": {
      color: "lightgrey"
    }
  }));

  const SaveDraftModal = ({ isOpen, onClose }) => {
    return (
      <Modal open={isOpen} onClose={onClose}>
        <div
          className="client-modal-responsive"
          style={{
            width: "auto"
          }}>
          <Typography
            mb={1}
            sx={{
              color: BIGrey
            }}
            textAlign={"center"}>
            {TEXT_DETAILS_INSPECTION}
          </Typography>
          <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
            <LoadingButton
              startIcon={<></>}
              sx={{
                backgroundColor: "#e4e4e4",
                boxShadow: "none",
                borderRadius: "10px",

                color: "black",
                textTransform: "none"
              }}
              onClick={() => {
                handelBothTheModalClose();
              }}
              fullWidth
              size={"small"}>
              {TEXT_MODAL_DISCARD}
            </LoadingButton>
            <LoadingButton
              sx={{
                backgroundColor: CLIENT_ACCENT_COLOR,
                boxShadow: "none",
                borderRadius: "10px",

                color: "white",
                textTransform: "none"
              }}
              onClick={() => {
                onSubmit(true);
              }}
              fullWidth
              startIcon={<></>}
              loadingPosition="start"
              loading={loadingButton}
              size={"small"}>
              {TEXT_SAVE_DRAFT}
            </LoadingButton>
          </Stack>
        </div>
      </Modal>
    );
  };

  return (
    <>
      <Modal open={isOpen} onClose={HandelMainModelClose}>
        <div
          className="client-modal-responsive"
          style={{
            backgroundColor: "#e4e4e4"
          }}>
          {isLoading ? (
            <Stack width={"100%"} justifyContent={"center"}>
              <Loader />
            </Stack>
          ) : (
            <>
              <Stack display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                <Typography variant="h5" fontWeight={"bold"} color={BIGrey}>
                  {modalHeading}
                </Typography>
                <IconButton onClick={HandelMainModelClose} sx={{ p: 0, color: selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              {data.length > 0 ? (
                <>
                  <Grid
                    size={12}
                    maxHeight={"500px"}
                    sx={{ scrollbarWidth: "none" }}
                    overflow={"auto"}>
                  {data?.map((item, index) => (
                      <Grid mb={1} size={12} key={index}>
                        <Card
                          sx={{
                            boxShadow: "none",
                            borderRadius: "10px",
                            p: "0px",
                            backgroundColor:
                              item.itemInspectionStatus == "NA" ? "transparent" : "white"
                          }}>
                          <CardContent
                            sx={{
                              paddingBottom: "16px !important"
                            }}>
                            <Stack
                              display={"flex"}
                              alignItems={"center"}
                              flexDirection={"row"}
                              justifyContent={"space-between"}>
                              <Typography variant="subtitle1" fontWeight={"bold"} color={BIGrey}>
                                {item?.itemInspectionStatus == "NA" ? (
                                  <strike>{item?.itemName}</strike>
                                ) : (
                                  item?.itemName
                                )}
                              </Typography>

                              <Stack
                                display={"flex"}
                                ml={1}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                gap={1}>
                                <IconButton
                                  onClick={() => handelPass(index)}
                                  sx={{
                                    ":hover": {
                                      backgroundColor:
                                        item.itemInspectionStatus == "pass"
                                          ? BILightGreen
                                          : "#f2f2f2"
                                    },
                                    backgroundColor:
                                      item.itemInspectionStatus == "pass" ? BILightGreen : "#f2f2f2"
                                  }}
                                  size="small">
                                  <DoneIcon
                                    sx={{
                                      color: item.itemInspectionStatus == "pass" ? "green" : ""
                                    }}
                                  />
                                </IconButton>

                                <IconButton
                                  onClick={() => handelFail(index)}
                                  sx={{
                                    ":hover": {
                                      backgroundColor:
                                        item.itemInspectionStatus == "fail" ? BILightRed : "#f2f2f2"
                                    },
                                    backgroundColor:
                                      item.itemInspectionStatus == "fail" ? BILightRed : "#f2f2f2"
                                  }}
                                  size="small">
                                  <CloseIcon
                                    sx={{
                                      color: item.itemInspectionStatus == "fail" ? "red" : ""
                                    }}
                                  />
                                </IconButton>

                                {item.isNAApplicable && (
                                  <IconButton
                                    onClick={() => handelNa(index)}
                                    sx={{
                                      ":hover": {
                                        backgroundColor:
                                          item.itemInspectionStatus === "NA" ? "#a4a4a4" : "#f2f2f2"
                                      },
                                      backgroundColor:
                                        item.itemInspectionStatus === "NA" ? "#a4a4a4" : "#f2f2f2"
                                    }}
                                    size="small">
                                    <Typography
                                      sx={{
                                        p: "1px",
                                        m: 0
                                      }}
                                      fontSize={12}>
                                      N/A
                                    </Typography>
                                  </IconButton>
                                )}
                              </Stack>
                            </Stack>

                            {item?.itemInspectionStatus !== "NA" &&
                              item.itemInspectionStatus != "" && (
                                <Grid
                                  mt={1}
                                  spacing={1}
                                  size={{
                                  xl:12,
                                  lg:12,
                                  md:12,
                                  sm:12,
                                  xs:12,
                                  }}
                                  container>
                                  {item.isPictureApplicable && (
                                    <Grid size={12} spacing={1}>
                                      <ClickableText
                                        onClick={() => {
                                          inputRef.current.click();
                                          setAdImageIndex(index);
                                        }}
                                        style={{
                                          color: CLIENT_ACCENT_COLOR,
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          userSelect: "none"
                                        }}>
                                        {TEXT_DETAILS_ADD_PICTURE}
                                        {item.isPictureMandatory && TEXT_REQUIRED}
                                      </ClickableText>
                                      <Stack
                                        display={"flex"}
                                        flexDirection={"row"}
                                        width={"100%"}
                                        gap={1}
                                        sx={{
                                          overflowX: "auto"
                                        }}>
                                        <ImageMemoWrapped
                                          key={index}
                                          mainIndex={index}
                                          file={item.pictureList}
                                          handelImageRemove={handelImageRemove}
                                          setPictureIndex={setPictureIndex}
                                          setPictureListArray={setPictureListArray}
                                          setShowPictureView={setShowPictureView}
                                          selectedClientData={selectedClientData}
                                        />
                                      </Stack>
                                    </Grid>
                                  )}
                                  {item.isCommentApplicable && (
                                    <Grid pt={0} size={12}>
                                      <TextField
                                        onChange={(e) => handleTextChange(e, item.id)}
                                        slotProps={{
                                          input: {
                                            rows: 4,
                                            multiline: true,
                                            inputComponent: "textarea"
                                          }
                                        }}
                                        value={item.comment}
                                        fullWidth
                                        rows={4}
                                        sx={{
                                          borderRadius: "10px",
                                          "& fieldset": {
                                            border: "none"
                                          },
                                          border: "1px solid #e4e4e4"
                                        }}
                                        // placeholder={`TEXT_WRITE_SOMETHING ${
                                        //   item.isCommentMandatory ? TEXT_REQUIRED : ""
                                        // }`}

                                        placeholder={
                                          item.isCommentMandatory
                                            ? TEXT_WRITE_SOMETHING
                                            : TEXT_WRITE_SOMETHING
                                        }
                                      />
                                    </Grid>
                                  )}
                                </Grid>
                              )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                    <Grid p={2} borderRadius={2} backgroundColor={"white"} size={12} container>
                      <Grid size={12}>
                        <ProgressBar
                          passCount={count.passCount}
                          failCount={count.failCount}
                          total={count.totalCount}
                        />
                      </Grid>
                      <Grid mb={2} mt={2} size={12}>
                        <Typography variant="subtitle1" color={BIGrey}>
                          {TEXT_DETAILS_COMPLETED_SIGNED_OFF}
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Stack>
                          <Typography mb={1}>{TEXT_SIGNATURE}</Typography>
                          <Box
                            sx={{
                              position: "relative"
                            }}>
                            <SignaturePadMemo setBlob={setSignBlob} />
                          </Box>
                        </Stack>
                        <LoadingButton
                          style={{
                            borderRadius: "10px",
                            marginTop: "10px",
                            backgroundColor: !isButtonDisabled() ? CLIENT_ACCENT_COLOR : "#e4e4e4",
                            color: "white",
                            textTransform: "none"
                          }}
                          disabled={isButtonDisabled()}
                          onClick={() => {
                            onSubmit(false);
                          }}
                          startIcon={<SaveIcon />}
                          loadingPosition="start"
                          loading={loadingButton && !saveDraft}
                          fullWidth>
                          {TEXT_DETAILS_SUBMIT}
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  <input
                    onChange={handelImageChange}
                    type="file"
                    id="file"
                    ref={inputRef}
                    style={{ display: "none" }}
                    multiple
                    accept="
                image/png, image/jpeg, image/jpg"
                  />
                  <SaveDraftModal
                    isOpen={saveDraft}
                    onClose={() => {
                      setSaveDraft(false);
                    }}
                  />
                </>
              ) : (
                <>
                  <Typography>{TEXT_DETAILS_NO_DATA}</Typography>
                </>
              )}
            </>
          )}
        </div>
      </Modal>
      <PictureViewer
        isOpen={showPictureView}
        onClose={() => setShowPictureView(false)}
        pictures={pictureListArray?.map((item) => {
          if (item?.isLocal) {
            return { src: URL.createObjectURL(item.file) };
          }
          if (item?.fileUrl) {
            return { src: item.fileUrl };
          }
          if (item?.fileName) {
            return { src: item.fileName };
          }

          return { src: item.id ? item.fileUrl : URL.createObjectURL(item) };
        })}
        viewerIndex={pictureIndex}
      />
    </>
  );
};

const ImageComponent = (props) => {
  const {
    file,
    handelImageRemove,
    mainIndex,
    setPictureIndex,
    setPictureListArray,
    setShowPictureView,
    selectedClientData
  } = props;

  const imgUrl = (img) => {
    try {
      return URL.createObjectURL(img);
    } catch (error) {
      return img;
    }
  };
  return (
    <>
      <Grid container spacing={1} marginTop={1}>
        {file?.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              position: "relative"
            }}>
            <img
              loading="lazy"
              onClick={() => {
                setPictureIndex(index);
                setPictureListArray([...file]);
                setShowPictureView(true);
              }}
              style={{
                objectFit: "cover",
                minWidth: "100px",
                maxWidth: "100px",
                maxHeight: "100px",
                minHeight: "100px",
                borderRadius: "10px",
                cursor: "pointer"
              }}
              src={item.fileName || item.fileUrl || imgUrl(item.file)}
              alt=""
            />
            <IconButton
              size="small"
              sx={{
                height: 20,
                width: 20,
                position: "absolute",
                top: 0,
                right: 0,
                color:
                  selectedClientData?.AccentColor !== undefined &&
                    selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey,
                backgroundColor: "rgba(0,0,0,0.3)"
              }}
              onClick={() => handelImageRemove(mainIndex, index, item)}>
              <CloseIcon
                sx={{
                  fontSize: 17,
                }}
              />
            </IconButton>
          </div>
        );
      })}
      </Grid>
    </>
  );
};

const ImageMemoWrapped = memo(ImageComponent);

const SignaturePad = ({ setBlob }) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_MODAL_CLEAR } = ClientEnglishFallback.QualityControlModal(
    multiLanguageData?.QualityControlModal || {}
  );
  const signPadRef = useRef();
  const [showClear, setShowClear] = useState(false);

  const ClickableText = styled(Typography)(({ theme }) => ({
    cursor: "pointer",
    transition: " color 0.1s ease",
    "&:hover": {},

    userSelect: "none",
    "&:active": {
      color: "lightgrey"
    }
  }));

  const getSignImg = useCallback(() => {
    const canvas = signPadRef.current.getCanvas();
    if (!canvas) return;

    canvas.toBlob(
      (blob) => {
        setBlob(blob);
      },
      "image/png",
      1.0
    );
  }, []);

  return (
    <div style={{ width: "100%", maxWidth: "600px", margin: "0 auto" }}>
      <ReactSignatureCanvas
        onBegin={() => { }}
        clearOnResize={false}
        ref={signPadRef}
        penColor="black"
        onEnd={() => {
          setShowClear(true);
          getSignImg();
        }}
        canvasProps={{
          className: "sigCanvas"
        }}
      />
      <style>
        {`
          .sigCanvas {
            width: 100% !important;
            height: 150px !important;
            border: 1px solid #e4e4e4; 
            border-radius: 10px;
          }
        `}
      </style>

      {showClear && (
        <ClickableText
          onClick={() => {
            signPadRef.current.clear();
            setShowClear(false);
            setBlob(null);
          }}
          variant="p"
          size="small"
          sx={{
            position: "absolute",
            top: 2,
            right: 7,
            zIndex: 100,
            color: CLIENT_COLOR
          }}>
          {TEXT_MODAL_CLEAR}
        </ClickableText>
      )}
    </div>
  );
};

const SignaturePadMemo = memo(SignaturePad);
